import { EMPTY_OBJECT } from 'commons-ui';
import { URL, APK_UPDATE_RESOURCES } from '../../helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.apkVersionInfo]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.apkVersionInfo]}/clone`,
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.apkVersionInfo]}/create`
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
